export const METALLIC_PROGRESS_COLORS = [
  "#542F27",
  "#B76545",
  "#F2B387",
  "#F5C882",
  "#B76545",
] as const;
